import { x0, x } from "../../../_helpers";

export default class Search {
  constructor() {
    this.el = x0(".fo-search-btn");
    if (!this.el) return;
    this.init();
  }

  toggleSearch(e, isSearchOpen) {
    e.preventDefault();
    this.searchField = x0("[js-search]");

    if (!this.searchField) {
      return;
    }

    if (isSearchOpen) {
      const searchClose = this.searchField.querySelector(".fo-search__close"); // Sostituisci 'selettore' con il selettore dell'elemento
      if (searchClose) {
        searchClose.removeAttribute('aria-label');
        searchClose.setAttribute("aria-hidden", "true");
      }

      this.searchField.classList.remove("-is-active");
      this.searchField.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('-search-is-open');

      const accessibleElements = this.searchField.querySelectorAll('[tabindex="0"]');
      if (accessibleElements?.length) {
        accessibleElements.forEach(element => {
          element.setAttribute('tabindex', '-1');
          element.setAttribute('aria-hidden', 'true')
        });
      }
    } else {
      const searchClose = this.searchField.querySelector(".fo-search__close"); // Sostituisci 'selettore' con il selettore dell'elemento
      if (searchClose) {
        searchClose.setAttribute("aria-label", "Close search panel");
        searchClose.setAttribute("aria-hidden", "false");
      }

      this.searchField.classList.add("-is-active");
      this.searchField.setAttribute('aria-hidden', 'false');
      document.body.classList.add('-search-is-open');

      const accessibleElements = this.searchField.querySelectorAll('[tabindex="-1"]');
      if (accessibleElements?.length) {
        accessibleElements.forEach(element => {
          element.setAttribute('tabindex', '0');
          element.setAttribute('aria-hidden', 'false')
        });
      }
    }

    const input = x0("input", this.searchField);
    if (input) {
      input.focus();
    }
  }

  attachEvents() {
    const that = this;
    //open search

    if (this.searchOpener.length > 0) {
      this.searchOpener.forEach((el) => {
        el.addEventListener("click", function (e) {
          that.toggleSearch(e, false);
        });
      });
    }

    if (this.searchCloser.length > 0) {
      this.searchCloser.forEach((el) => {
        el.addEventListener("click", function (e) {
          that.toggleSearch(e, true);
        });
      });
    }
  }

  init() {
    this.searchOpener = x("[js-search-open]");
    this.searchCloser = x("[js-menu-close]");

    this.attachEvents();
  }
}
